/**
 * كشف نسخةٍ أحدث من النظام نُشرت والتبويب مفتوح.
 *
 * كل نشرٍ يولّد ملف دخولٍ باسمٍ مُهشّم جديد (`/assets/main-<hash>.js`) يشير إليه
 * index.html، والأخير يُقدَّم بلا تخزين (no-store). فإن أشار index.html الآن لملفٍ غير
 * الذي تعمل به الصفحة، فالتبويب يعمل بنسخةٍ قديمة — أي إصلاحٍ أو تحديثٍ حيّ جديد
 * لا يصله حتى يُعاد تحميله.
 */

const ENTRY_SCRIPT = 'script[type="module"][src]'

/** ملف الدخول المُهشّم الذي يشير إليه المستند — null خارج نسخة الإنتاج (بيئة التطوير) */
export function entryScriptOf(doc: ParentNode): string | null {
  const src = doc.querySelector(ENTRY_SCRIPT)?.getAttribute('src') ?? null
  return src && src.includes('/assets/') ? src : null
}

/**
 * هل نُشرت نسخةٌ أحدث مما تعمل به الصفحة؟
 * null = لا نعرف الآن (شبكة، خادمٌ يُعاد نشره، بيئة تطوير) — يُعاد الفحص لاحقاً.
 */
export async function isNewerVersionDeployed(signal?: AbortSignal): Promise<boolean | null> {
  const running = entryScriptOf(document)
  if (!running) return null
  try {
    const res = await fetch(`/?v=${Date.now()}`, {
      cache: 'no-store',
      headers: { Accept: 'text/html' },
      signal,
    })
    if (!res.ok) return null
    const latest = entryScriptOf(new DOMParser().parseFromString(await res.text(), 'text/html'))
    return latest ? latest !== running : null
  } catch {
    return null
  }
}
